import html2canvas from 'html2canvas';
import React, { useRef, useState } from 'react';
import { copyToClipboard, showToast } from '../../utils/utils';
import QRCode from '../share-poster/qrcode';
// 商品数据类型
interface GoodsInfo {
  id: string;
  name: string;
  price: number; // 售价，0表示免费
  link: string; // 下单页面链接
  goodsHeadImg: string; // 下单页面链接
  logoUrl: string; // 卡管家logo地址
}

interface GoodsShareModalProps {
  visible: boolean;
  goods: GoodsInfo;
  onClose: () => void;
}

const GoodsShareModal: React.FC<GoodsShareModalProps> = ({ visible, goods, onClose }) => {
  const posterRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(false);

  if (!visible) return null;

  // 复制链接到剪贴板
  const handleCopyLink = async () => {
    try {
      await copyToClipboard(`${goods?.name}\n${goods.link}`);
      showToast('链接已复制');
    } catch (err) {
      console.error('复制失败', err);
    }
  };

  // 下载分享图片
  const handleDownloadImage = async () => {
    if (!posterRef.current) return;
    setLoading(true);

    try {
      const canvas = await html2canvas(posterRef.current, {
        useCORS: true,
        scale: 2,
        logging: false,
      });
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = `share_${Date.now()}.png`;
      link.click();
    } catch (err) {
      console.error('生成图片失败', err);
      alert('生成图片失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  // 价格文案
  const priceText = goods.price === 0 ? '立即领取，包邮到家！' : `商品售价：${goods.price}元`;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {/* 分享海报（Canvas生成区域） */}
        <div ref={posterRef} className="poster-container">
          <img className="bw-100" src={goods?.goodsHeadImg} alt="" />
          {/* 商品信息区 */}
          <div className="mb-5 font-widget-600">{goods.name}</div>

          <div className="d-flex-r">
            {/* 二维码（中间嵌Logo） */}
            <div className="pos-r w-120 h-120 mr-5">
              {/* 底层二维码 */}
              <QRCode val={goods?.link} size={230} />
              {/* 中间Logo：绝对定位、缩小、白边衬托 */}
              <img src={goods?.logoUrl} alt="logo" className="logo-qrcode" />
            </div>
            <div className="d-flex-c">
              <div className="d-flex-r flex-1 mt-10">
                <div className="d-flex-c font-size-10 mr-10">
                  <span className="text-color-9">识别或扫描二维码下单</span>
                  <span className="mt-10">{priceText}</span>
                </div>
                <img className="w-50 h-50" src={goods?.logoUrl} alt="" />
              </div>
              <div className="submit-logo">{goods.price === 0 ? '立即领取' : '立即下单'}</div>
            </div>
          </div>
        </div>

        {/* 操作按钮区 */}
        <div className="d-flex-r jc-around">
          <button onClick={handleDownloadImage} disabled={loading} className="action-btn">
            📥 下载图片
          </button>
          <button onClick={handleCopyLink} className="action-btn">
            🔗 复制链接
          </button>
        </div>

        <button onClick={onClose} className="cancel-btn">
          取消分享
        </button>
      </div>
    </div>
  );
};

export default GoodsShareModal;
